import React from 'react';
import { world } from '../../languages';

export default function Spacing() {
    return world === 'fr' ? <span>&nbsp;</span> : <></>;
}
